import React, {useContext} from 'react'; 
import ToCompanyInvestments from './ToCompanyInvestments';
import ToCompanyExists from './ToExits';
import ToInvestors from './ToInvestors';
import ToAcquirer from './ToAquirer';
import {TableDataContext} from '../../../Contexts/TableDataContext' 
 
/**
 * The `Card` component renders four different cards based on the `data` and `isDataLoad` values
 * received from the `TableDataContext`.
 * @returns The Card component is returning a JSX element.
 */
 const Card = () => {

  const { data, isDataLoad } = useContext(TableDataContext);
     
  return (
    <div className=""> 
      <div className='sm:full mt-[4.25rem] md:mt-[3rem] h-full  bg-[#F2F2F2]'>
           <div className="hidden md:block md:overflow-x-auto lg:grid lg:grid-cols-4 lg:gap-4 lg:px-4 lg:py-[0.7rem] lg:overflow-hidden" style={{scrollbarWidth: 'none'}}>
           <div className="md:grid md:grid-cols-4 md:gap-4 md:px-4 md:min-w-max lg:contents">
           {/* ----card1----- */}
           <ToCompanyInvestments data={data} isDataLoad={isDataLoad}/>
          {/* ----card2----- */}
          <ToCompanyExists data={data} isDataLoad={isDataLoad}/>
          {/* ----card3----- */}
          <ToInvestors data={data} isDataLoad={isDataLoad}/>
          {/* ----card4----- */}
          <ToAcquirer data={data} isDataLoad={isDataLoad}/> 
            </div>
            </div>
        <div className='border-b-2 border-[#e5e5e5]'></div>
      </div >
    </div >
  )
}

export default Card;
